
















































import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { AddEditChannelDto, AllowedPostSettings, Channel } from "@/services/channels/types";
import {
    getChannelById,
    updateChannel
} from "@/services/channels/channelsService";
import ChannelPosts from "@/components/channels/ChannelPosts.vue";
import { validateForm } from "@/services/validation/validationService";
import HeaderActionButtons from "@/components/layouts/HeaderActionButtons.vue";
import ChannelPreviewModal from "@/components/channels/modals/ChannelPreviewModal.vue";
import ChannelInfoModal from "@/components/channels/modals/ChannelInfoModal.vue";
import { setFavorite } from "@/services/favorites/favoriteService";
import { HavePermition, PermitionEnum } from "@/components/security/Permitions";
import { FavoriteDto, FavoriteEntityType } from "@/services/favorites/types";
import { bus } from "@/bus";

@Component({
    components: {
        ChannelPosts: ChannelPosts,
        HeaderActionButtons,
        ChannelPreviewModal,
        ChannelInfoModal
    }
})
export default class ChannelFormEditor extends Vue {
    @Getter("getCurrentUser", { namespace: "authentication" }) getCurrentUser: any;
    @Prop() private channelId!: string;
    @Prop() private folderId!: string;
    formState = false;
    channel = {
        folderId: this.folderId ? this.folderId : "",
        allowedPostTypes: [] as Array<AllowedPostSettings>
    } as Channel;

    selectedItemTypes = [] as string[];
    permitionEnum = PermitionEnum;
    havePermition = HavePermition;
    // lifecycle hooks
    created() {
        this.fetchData();
    }

    // computed
    get itemTypes(): string[] {
        return this.channel.allowedPostTypes.map(x => x.postType);
    }

    // methods
    save(back: boolean) {
        if (!this.formState) { return; }

        const channelDto =
            {
                channel: this.channel
            } as AddEditChannelDto;
        updateChannel(channelDto).then(() => {
            if (back) {
                this.$router.push({
                    name: "channels"
                });
            }
        });
    }

    onNewPostBtn() {
        (this.$refs.childComponent as any).addItem();
    }

    back() {
        window.history.go(-1);
    }

    async fetchData() {
        if (!this.channelId) return;

        this.channel = await getChannelById(this.channelId);
        this.selectedItemTypes = this.channel.allowedPostTypes.map(x => x.postType);
        bus.$emit("documentTitle", this.channel.name);
    }

    previewChannel(channelId: string, name: string) {
        (this.$refs.channelPreviewModal as any).open(channelId, name);
    }

    channelInfo(channelId: string) {
        (this.$refs.channelInfoModal as any).open(channelId);
    }

    toggleFavorite(channel: Channel) {
        const data = {
            entity: FavoriteEntityType.Channel,
            entityId: channel.id,
            state: !channel.favorite
        } as FavoriteDto;

        setFavorite(data).then(response => {
            channel.favorite = !channel.favorite;
        });
    }
}
